import React from 'react';
import styled from '@emotion/styled';

import ProductCard from '../ProductCard';
import VariantsList from '../VariantsList';
import VariantData from '../VariantData';

import PageTitle from '../../../common/PageTitle';

const Wrapper = styled('div')`
  flex-wrap: nowrap;
  .left-column {
    max-width: 300px;
    width: 33.333%;
    padding-right: 12px;
    padding-left: 12px;
    .card-name {
      margin-top: 15px;
    }
  }
  .right-column {
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }
  .card-box {
    margin-bottom: 25px;
    height: calc(100% - 25px);
  }
  .add-new-field {
    color: #7e57c2;
    cursor: pointer;
  }

  @media (max-width: 993px) {
    display: block;
    .left-column {
      width: 100%;
      max-width: 100%;
      .card-name {
        margin-top: 0;
      }
    }
  }
`;

const DesktopLayout = (props) => {
  const {
    pageTitle,
    breadcrumbs,
    currentProduct,
    isNew,
    features,
    currentVariant,
    setCurrentVariant,
    handleCloneVariant,
    isArchived,
    isValid,
    values,
    warehouses,
    setFieldValue,
    productId,
    loading,
    setLoading,
    history,
    fetchDeleteVariant,
    editVariant,
    handleSubmit,
    errors,
    showModal,
    setUnsavedStatus,
    handleExportMovements,
    refreshVariant,
    eshops,
    productsPriceMarginHistory,
    productMarginShipped,
    productMarginDelivered,
    haveProductsPriceMarginHistory,
    monoboxesUpdateRef,
  } = props;

  return (
    <>
      <PageTitle title={pageTitle} breadcrumbs={breadcrumbs} />
      <Wrapper className="row">
        <div className="left-column">
          <ProductCard product={currentProduct} />
          <VariantsList
            isNew={isNew}
            product={currentProduct}
            features={features}
            currentVariant={currentVariant}
            setCurrentVariant={setCurrentVariant}
            handleCloneVariant={handleCloneVariant}
          />
        </div>
        <div className="right-column">
          <VariantData
            isArchived={isArchived}
            isNew={isNew}
            isValid={isValid}
            product={currentProduct}
            variant={currentVariant}
            values={values}
            warehouses={warehouses}
            setFieldValue={setFieldValue}
            features={features}
            productId={productId}
            loading={loading}
            setLoading={setLoading}
            history={history}
            fetchDeleteVariant={fetchDeleteVariant}
            editVariant={editVariant}
            handleSubmit={handleSubmit}
            errors={errors}
            showModal={showModal}
            setUnsavedStatus={setUnsavedStatus}
            handleExportMovements={handleExportMovements}
            refreshVariant={refreshVariant}
            eshops={eshops}
            productsPriceMarginHistory={productsPriceMarginHistory}
            productMarginShipped={productMarginShipped}
            productMarginDelivered={productMarginDelivered}
            haveProductsPriceMarginHistory={haveProductsPriceMarginHistory}
            monoboxesUpdateRef={monoboxesUpdateRef}
          />
        </div>
      </Wrapper>
    </>
  );
};

export default DesktopLayout;
